<template>
    <div>
        <div class="top">
            <div>
                <img src="../../assets/imgs/logo1.png" />
            </div>
        </div>
        <div class="center">
            <div class="logo-left">
                <span>欢迎使用</span>
                <div>
                    <span>集微职场企业招聘平台</span>
                    <img src="../../assets/imgs/background-leftimg.png" />
                </div>
            </div>
            <div class="logo-box">
                <div class="title">账号密码登录</div>
                <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
                    <el-form-item class="element-input" prop="account">
                        <el-input
                        ref="username"
                        v-model="loginForm.account"
                        placeholder="账号"
                        name="username"
                        type="text"
                        tabindex="1"
                        auto-complete="on"
                        />
                    </el-form-item>
                    <el-form-item class="element-input" prop="password">
                        <el-input
                        :key="passwordType"
                        ref="password"
                        v-model="loginForm.password"
                        :type="passwordType"
                        placeholder="密码"
                        name="password"
                        tabindex="2"
                        auto-complete="on"
                        @keyup.enter.native="handleLogin"
                        />
                    </el-form-item>
                    <span class="checkbox">
                        <el-checkbox v-model="checked" @change="setLoginForm">自动登录</el-checkbox>
                        <!-- <span>* 账号或密码错误请重新输入</span> -->
                        <router-link to="/forgotpwd" tag="span" class="forgot-pwd">忘记密码</router-link>
                    </span>
                    <el-button :loading="loading" style="width: 100%;margin-top: 30px;" type="primary" @click.native.prevent="handleLogin">登录</el-button>
                    <p class="tip">如需注册企业账号，或账号使用有任何问题，请联系韩先生：18918459526</p>
                </el-form>
            </div>
        </div>
        <div class="bottom">
            <span>Copyright 2007-{{currentYear}}©LaoYaoBa.com™Inc.All rights reserved | 闽ICP备17032949号-2</span>
            <span style="margin-top:6px;">闽公网安备 35020502000344号</span>
        </div>
    </div>
</template>
<script>
import { Message } from 'element-ui'
import Login from "@/api/Login"
import GetUserMsg from "@/api/PublicModule"
import { settoken_type, setlast_login,setToken} from '@/utils/auth'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            // 测试
            if (!value) {
                callback(new Error('账号不能为空'))
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            // 测试
            if (!value) {
                callback(new Error('密码不能为空'))
            } else {
                callback()
            }
        }
        return {
          currentYear: '',
            loginForm: {
                account: '',
                password: ''
            },
            loginRules: {
                account: [{ required: true, trigger: 'blur', validator: validateUsername }],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }]
            },
            loading: false,
            passwordType: 'password',
            redirect: undefined,
            checked:false
        };
    },
    watch: {
        $route: {
            handler: function(route) {
                this.redirect = route.query && route.query.redirect
            },
            immediate: true
        }
    },
    methods: {
        //记住密码
        setLoginForm(){
            if(this.checked){
                localStorage.setItem('isLogin','1');
                localStorage.setItem('loginForm',JSON.stringify(this.loginForm));
            }else{
                localStorage.setItem('isLogin','2');
                localStorage.setItem('loginForm',JSON.stringify({}));
            }
        },
        getUserMsgDetail(){//获取该账号的信息
            GetUserMsg.getUserMsg()
            .then((res) => {
                localStorage.setItem('account',JSON.stringify(res.data.data))
            }).catch((err) => {
                console.log(err)
            });
        },
        handleLogin() {
            this.$refs.loginForm.validate(valid => {
            if (valid) {
                Login.getLogin(this.loginForm)
                .then((res) => {
                    this.loading = false;
                    settoken_type(res.data.token_type)
                    setlast_login(res.data.user_last_login)
                    setToken(res.data.token)
                    this.$router.push({ path: this.redirect || '/' })
                    // this.getUserMsgDetail()
                    this.$router.push({
                        path:"/mymsg"
                    })
                }).catch((err) => {
                    if(err.data.status===201){
                        this.$message.error('账号密码错误');
                    }else if(err.data.status===202){
                        this.$message.error('账号异常，请联系运营人员');
                    }
                    this.loading = false
                });
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        }
    },
    mounted(){
        var that = this;
        var isLogin = JSON.parse(localStorage.getItem('isLogin'))||{};
        var loginForm = JSON.parse(localStorage.getItem('loginForm'))||{}
        if(isLogin===1){
            this.loginForm = loginForm;
            this.checked = true;
            setTimeout(function(){
                that.handleLogin()
            },500)
        }else{
            this.loginForm = {};
            this.checked = false;
        }
  },
  created(){
        let date = new Date();
        this.currentYear = date.getFullYear();
    },
}
</script>
<style scoped>
    .top{
        height: 72px;
        background-color: #fff;
        -webkit-box-shadow: 0 0 4px #ddd;
        box-shadow: 0 0 4px #ddd;
    }
    .top div{
        max-width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
    }
    .center{
        min-height: 421px;
        height: calc(100vh - 278px);
        background: url('../../assets/imgs/banckground-img.png');
        background-repeat: no-repeat;
        background-position: center center;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        -webkit-justify-content: center;
        align-items: center;
        -webkit-align-items: center;
    }
    .logo-left{
        position: relative;
    }
    .logo-left>span{
        position: absolute;
        left: 87px;
        height:32px;
        font-size:24px;
        color:#666666;
        line-height:32px;
        letter-spacing:1px;
    }
    .logo-left>div{
        margin-top: 27px;
        position: relative;
        min-width: 560px;
    }
    .logo-left>div>span{
        position: absolute;
        left: 87px;
        top: 13px;
        height:36px;
        font-size:27px;
        font-weight:bold;
        color:#0077FF;
        line-height:36px;
        letter-spacing:1px;
    }
    .logo-box{
        background:rgba(255,255,255,1);
        border-radius:5px;
        margin-left: 27px;
        padding: 50px 25px 25px;
    }
    .logo-box .title{
        font-size:20px;
        color:#666666;
        line-height:27px;
        margin-bottom: 20px;
    }
    .logo-box .checkbox{
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        font-size:12px;
        color:#FF1935;
        line-height:16px;
    }
    .logo-box .checkbox .forgot-pwd{
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #0077FF;
        cursor: pointer;
    }
    .element-input{
        width: 287px;
        height: 42px;
        /* margin-top: 9px; */
        /* margin-bottom: 6px; */
    }
    .bottom{
        height: 206px;
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        justify-content: center;
        -webkit-justify-content: center;
        text-align: center;
        font-size:12px;
        color:#333333;
        line-height:16px;
    }
    .tip{
      width: 276px;
      font-size: 12px;
      color: #606266;
      text-align: center;
      margin: 10px auto 0;
    }
</style>
<style>
    .el-checkbox__label{
        font-size:12px!important;
    }
</style>



// WEBPACK FOOTER //
// src/views/my/login.vue